import React, { FunctionComponent } from 'react';
import styles from './DotsMenu.module.scss';
import { makeStyles } from '@material-ui/core/styles';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';
import { Fade } from '@material-ui/core';
import { _t } from 'app/utils/i18n';
import { constants, getFromLocalStorage } from 'app/utils/localStorage';
import { exportAsPicture } from 'app/utils/exportToPng';
import { MoreVert } from '@material-ui/icons';
import { dateTimeFormatter } from 'app/utils/dateTimeFormatter';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  paper: {
    border: '1px solid var(--borderColor)',
    padding: theme.spacing(2.5),
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'start',
  },
}));

interface Props {
  id?: string;
  items?: { name: string; id: string }[];
  onClick?: (id: string) => void;
  testLanguage?: string;
  dataId?: string | number;
  isTweet?: boolean;
  showRegrab?: boolean;
  extraOptions?: unknown[];
}

const DotsMenu: FunctionComponent<Props> = ({
  id,
  testLanguage,
  items,
  onClick,
  extraOptions,
  dataId,
  showRegrab,
}) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<any>(null);
  const lang = testLanguage
    ? testLanguage
    : getFromLocalStorage(constants.language);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: any) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);
  return (
    <div data-testid="dots-menu" id={'dots-menu'} className={styles.DotsMenu}>
      {/* <div className={classes.root}> */}
      <div>
        <button
          ref={anchorRef}
          aria-controls={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          data-testid="dots-icon-holder"
        >
          <MoreVert />
        </button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          placement={lang == 'en' ? 'bottom-end' : 'bottom-start'}
          role={undefined}
          transition
          disablePortal
          data-testid="popper-holder"
        >
          {({ TransitionProps }) => (
            <ClickAwayListener
              onClickAway={handleClose}
              data-testid="listener-holder"
            >
              <Fade {...TransitionProps} timeout={350}>
                <div className={`${classes.paper} ${styles.popperMenu}`}>
                  {items ? (
                    items?.map((item) => (
                      <button
                        key={item.id}
                        onClick={() => {
                          onClick?.(item.id);
                          handleToggle();
                        }}
                        className={styles.ExportPNG}
                        data-testid="ExportPNG"
                      >
                        {item.name}
                      </button>
                    ))
                  ) : (
                    <ul>
                      <li>
                        <button
                          onClick={
                            testLanguage
                              ? () => handleToggle()
                              : () => {
                                  handleToggle();
                                  setTimeout(
                                    () => exportAsPicture(id ? id : ''),
                                    0,
                                  );
                                }
                          }
                          className={styles.ExportPNG}
                          data-testid="Export-holder"
                        >
                          {_t('basic:Export_PNG')}
                        </button>
                      </li>
                      {extraOptions?.length && showRegrab ? (
                        extraOptions?.map((item: any) => (
                          <li
                            key={item.title}
                            className={
                              !!item?.isDimmed ? styles.optionDimmed : ''
                            }
                          >
                            <span
                              onClick={() => {
                                !!item?.isDimmed
                                  ? undefined
                                  : item.mutateFun.mutateAsync({ id: dataId });
                              }}
                              aria-disabled={!!item?.isDimmed}
                            >
                              {item.title}
                            </span>
                            {item?.lastGrabbed && (
                              <div>
                                {_t('basic:last_grabbed_on')} :
                                {dateTimeFormatter?.date(item?.lastGrabbed!)}
                              </div>
                            )}
                          </li>
                        ))
                      ) : (
                        <></>
                      )}
                    </ul>
                  )}
                </div>
              </Fade>
            </ClickAwayListener>
          )}
        </Popper>
      </div>
      {/* </div> */}
    </div>
  );
};

export default DotsMenu;
